import hasAccessIssue from './hasAccessIssue';
import AccessIssue, { AccessIssues } from '../schema/AccessIssue';
import { AttachmentConstants } from 'owa-attachment-file-types/lib/utils/attachmentConstants';
import AttachmentType from 'owa-service/lib/contract/AttachmentType';

export function getAccessIssues(): AccessIssue[] {
    return AccessIssues.filter(hasAccessIssue);
}

export function getAccessIssuesForAttachments(attachments: AttachmentType[]): AccessIssue[] {
    return attachments && attachments.length > 0 && hasNonInlineAttachment(attachments)
        ? AccessIssues.filter(hasAccessIssue)
        : [];
}

function hasNonInlineAttachment(attachments: AttachmentType[]) {
    return attachments.some(a => !isInline(a));
}

function isInline(attachment: AttachmentType): boolean {
    return attachment.IsInline && !isCloudyAttachment(attachment);
}

function isCloudyAttachment(attachment: AttachmentType): boolean {
    return attachment.__type === AttachmentConstants.attachmentTypes.REFERENCE_ATTACHMENT_TYPE;
}
